import { environment } from 'src/environments/environment';

/**
 * Enable optional override of the default IDP specified in environment.ts
 * This will allow us to test with b2c accounts even if we default to atlas/auth0 in prod.
 * 
 * To override, add `?idp=clearsign` to host url
 */
export function getDomainHint(): string {
  if (typeof window === 'undefined') {
    return environment.auth.defaultIdentityProvider;
  }

  const params = new URLSearchParams(window.location.search);
  return params.get('idp') || environment.auth.defaultIdentityProvider;
}
